import gql from 'graphql-tag';

export const updateOpAlertLog = gql`
  mutation updateOpAlertLog($input: OpAlertLogInput) {
    updateOpAlertLog(input: $input) {
      id
      opLogStatus
      facilityId
      state
      county
      township
      businessUnitId
      createdBy
      createdAt
      updatedBy
    }
  }
`;
